// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { roundAndCastToString } from 'helpers/reduxFormFunctions'

const makeRadioPowerData = (label, coordinatedPower, maxPower, nominalPowerLevel) => ({
  label,
  coordinatedPower: roundAndCastToString(coordinatedPower, 2) || '-',
  maxPower: roundAndCastToString(maxPower, 2) || '-',
  nominalPowerLevel: roundAndCastToString(nominalPowerLevel, 2) || '-',
  uniqueId: 'label',
})

export default makeRadioPowerData
